import { queryUsers } from "@/services/user/user.service"
import { Select, Spin } from "antd"
import { useMemo, useRef, useState } from "react"
import { debounce } from "lodash"

interface ValueType {
  label: string
  value: any
}

interface UserSelectProps {
  value?: any
  onChange?: (val: any) => void,
  defaultOptions?: ValueType[]
}

export const UserSelect = (props: UserSelectProps) => {
  const {value, onChange, defaultOptions} = props;
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState<ValueType[]>(defaultOptions || []);
  const fetchRef = useRef(0);

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);

      queryUsers(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        const newUsers = newOptions.map(item => {
          return {value: item.id, label: item.email}
        })

        setOptions(newUsers);
        setFetching(false);
      });
    };

    return debounce(loadOptions, 800);
  }, []);
  
  return <Select
    value={value}
    onChange={(option) => onChange?.(option.value)}
    labelInValue
    filterOption={false}
    onSearch={debounceFetcher}
    notFoundContent={fetching ? <Spin size="small" /> : 'No results found'}
    options={options}
    showSearch
  />
}